
import { Telephone } from "react-bootstrap-icons/dist";

export const LogoText = () => {
  return (
    
        <span className="fw-bold text-primary">
            Certified<span style={{ color: '#082042' }}>Bankcard</span>
        </span>
    
  );
};

export const Logo = () => {
  return (
    
        <span className="fw-bold text-primary fs-3">
            <img src="/images-CertifiedBankcard/CBank-Logo.jpg" width="40" /> Certified<span style={{ color: '#082042' }}>Bankcard.com</span> 
        </span>
    
  );
};


type ContactPhoneNumberProps = {
  phoneNumber_tel: string;
  phoneNumberFormatted: string;
};


export const ContactPhoneNumber = ({phoneNumber_tel, phoneNumberFormatted}: ContactPhoneNumberProps) => {

  return  (
     <a href={`tel:${phoneNumber_tel}`} className={`text-decoration-none fw-semibold text-black`}>
                  <Telephone className="me-2 text-primary" />
                    {phoneNumberFormatted}
                </a>
          )


};